var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var ContentController = {
    /*****************************************************************************************************
        * Is using route "api/content/categoryById/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {CategoryDownloadDto}
    ******************************************************************************************************/
    GetCategoryById: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/categoryById/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Category/mapped" and http method "POST" to call the back-end.
    
        * @param {AdjacentDefinition} definition
        * @returns {ExtendedDataCollection<CategoryDownloadDto, ElementNode<CategoryDownloadDto>[]>}
    ******************************************************************************************************/
    GetCategoriesForAllGroupsByGroupTypeMapped: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("definition", JSON.stringify(data.definition));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/mapped", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/Category/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetCategoriesForAllGroupsByGroupTypeWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/Category/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/ContentPostContentLocation/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetContentPostContentLocationsForAllGroupsByGroupTypeWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/ContentPostContentLocation/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/Category/forCategoryType/{categoryType}/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} categoryType
        * @param {string} grouptype
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetCategoriesForAllGroupsByGroupTypeForCategoryTypeWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/Category/forCategoryType/{categoryType}/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/ContentPostContentLocation/forCategoryType/{categoryType}/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} categoryType
        * @param {string} grouptype
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetContentPostContentLocationsForAllGroupsByGroupTypeForCategoryTypeWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/ContentPostContentLocation/forCategoryType/{categoryType}/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Category/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {CategoryDownloadDto[]}
    ******************************************************************************************************/
    GetCategoriesForAllGroupsByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    GetContentPostContentLocationForAllGroupsByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    GetContentPostContentTypeForAllGroupsByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    GetContentPostMediaTypeForAllGroupsByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Competence/all/{grouptype?}" and http method "GET" to call the back-end.
    
        * @param {string} grouptype
        * @returns {CompetenceDownloadDto[]}
    ******************************************************************************************************/
    GetCompetenceForAllGroupsByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Competence/all/{grouptype?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Category/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {CategoryDownloadDto[]}
    ******************************************************************************************************/
    GetCategories: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/Category/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetCategoriesWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/Category/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/ContentPostContentLocation/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetContentPostContentLocationsWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/ContentPostContentLocation/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/Category/forCategoryType/{categoryType}/inGroup/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} categoryType
        * @param {string} groupid
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GetCategoriesForCategoryTypeWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/Category/forCategoryType/{categoryType}/inGroup/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/withConfigurations/ContentPostContentLocation/forCategoryType/{categoryType}/inGroup/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} categoryType
        * @param {string} groupid
        * @returns {ConfigurationsWithCategories}
    ******************************************************************************************************/
    GeContentPostContentLocationsForCategoryTypeWithConfigurations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/withConfigurations/ContentPostContentLocation/forCategoryType/{categoryType}/inGroup/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    GetContentPostMediaTypes: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    GetContentPostContentType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    GetContentPostContentLocations: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Competence/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {CompetenceDownloadDto[]}
    ******************************************************************************************************/
    GetCompetences: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Competence/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Category" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {CategoryUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {CategoryDownloadDto}
    ******************************************************************************************************/
    PostCategory: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostMediaTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    PostMediaType: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostContentTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    PostContentType: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {ContentPostContentLocationUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    PostLocation: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Competence" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {CompetenceUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {CompetenceDownloadDto}
    ******************************************************************************************************/
    PostCompetence: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Competence", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Category/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {CategoryUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {CategoryDownloadDto}
    ******************************************************************************************************/
    PatchCategory: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostMediaTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    PatchMediaType: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostContentTypeUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    PatchContentType: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {ContentPostContentLocationUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    PatchLocation: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Competence/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {CompetenceUploadDto} data
        * @param {File} svgFile
        * @param {File} svgFileAlt
        * @param {File} banner
        * @returns {CompetenceDownloadDto}
    ******************************************************************************************************/
    PatchCompetence: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        fd.append("data", JSON.stringify(data.data));
        if (data.svgFile)
            fd.append("svgFile", data.svgFile);
        if (data.svgFileAlt)
            fd.append("svgFileAlt", data.svgFileAlt);
        if (data.banner)
            fd.append("banner", data.banner);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Competence/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/Category/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {CategoryDownloadDto[]}
    ******************************************************************************************************/
    CopyCategory: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/Category/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostMediaType/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {ContentPostMediaTypeDownloadDto[]}
    ******************************************************************************************************/
    CopyMediaType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostMediaType/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentType/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {ContentPostContentTypeDownloadDto[]}
    ******************************************************************************************************/
    CopyContentType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentType/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/content/ContentPostContentLocation/{id}/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} groupid
        * @returns {ContentPostContentLocationDownloadDto[]}
    ******************************************************************************************************/
    CopyContentLocation: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/content/ContentPostContentLocation/{id}/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ContentController.js.map